import { Page } from '@/components';
import HistoricTabs from './HistoricTabs';
import DAIEventsTable from './MKREventsTable';
import { CryptoIcon, ArrowSwitchIcon, Heading, Flex } from '@blockanalitica/ui';
import { tokensMapping } from '@/utils/tokens';
import { KpiEntityName } from '@/components';

export default function MKREventsPage() {
  return (
    <Page
      title={
        <Flex gap="2xs" alignItems="center">
          <KpiEntityName
            symbol1={<CryptoIcon name="MKR" size="3" />}
            symbol2={
              <CryptoIcon
                name="SKY"
                address={tokensMapping('SKY').address}
                size="3"
              />
            }></KpiEntityName>
          <Heading size="1">
            <Flex gap="xs" alignItems="center">
              MKR <ArrowSwitchIcon /> SKY Activity
            </Flex>
          </Heading>
        </Flex>
      }>
      <HistoricTabs />
      <DAIEventsTable />
    </Page>
  );
}
